module.exports = __webpack_public_path__ + "assets/img/dailyTask-bottom-left.2f677429.png";